import React from "react";
import { ModuleKey } from "types/permissions";
import { ScreenType } from "components/WarningSnackbar";
import { PATHS } from "./paths";
import Layout from "pages/Layout/Layout";
import MinimalLayout from "pages/Layout/MinimalLayout";
import AcademyLayout from "pages/AcademyPage/AcademyLayout";
const AcademyPage = React.lazy(() => import("pages/AcademyPage/AcademyPage"));
const AcademyDetailPage = React.lazy(() => import("pages/AcademyPage/AcademyDetailPage"));
const AcademyWatchPage = React.lazy(() => import("pages/AcademyPage/AcademyWatchPage"));
const AcademyAllCourses = React.lazy(() => import("pages/AcademyPage/components/AllCourses"));
const AcademyVerifyPage = React.lazy(() => import("pages/AcademyPage/AcademyVerifyPage"));

const TrendsPage = React.lazy(() => import("pages/TrendsPage"));
const TrendDataPage = React.lazy(() => import("pages/TrendDataPage/TrendDataPage"));
const TrendsHistoryPage = React.lazy(() => import("pages/TrendDataPage/TrendsHistoryPage"));
const RetailDataPage = React.lazy(() => import("pages/TrendDataPage/RetailPages").then((m) => ({ default: m.RetailDataPage })));
const RetailDataStoryPage = React.lazy(() => import("pages/TrendDataPage/RetailPages").then((m) => ({ default: m.RetailDataStoryPage })));
const BrandDnasPage = React.lazy(() => import("pages/BrandDnasPage"));
const ColorPalettesPage = React.lazy(() => import("pages/ColorPalettesPage"));
const BrandKitsPage = React.lazy(() => import("pages/BrandKitsPage"));
const IntegrationsPage = React.lazy(() => import("pages/IntegrationsPage"));
const MiroCallbackPage = React.lazy(() => import("pages/MiroCallbackPage"));
const CreateMoodboardAddPage = React.lazy(() => import("pages/CreateMoodboardAddPage"));
const CreateBrandKitAddPage = React.lazy(() => import("pages/CreateBrandKitAddPage"));
const CreateBackgroundPage = React.lazy(() => import("pages/CreateBackgroundPage"));
const StyleTrainingPage = React.lazy(() => import("pages/StyleTrainingPage"));
const FabricTrainingPage = React.lazy(() => import("pages/FabricTrainingPage"));
const ModelTrainingPage = React.lazy(() => import("pages/ModelTrainingPage"));
const Login = React.lazy(() => import("pages/Login"));
const SignUp = React.lazy(() => import("pages/SignUp"));
const CheckoutPage = React.lazy(() => import("pages/CheckoutPage"));
const AuthMagicPage = React.lazy(() => import("pages/AuthMagicPage"));
const ImpersonatePage = React.lazy(() => import("pages/ImpersonatePage"));
const GuestSuccessPage = React.lazy(() => import("pages/GuestSuccessPage"));
const SetPasswordPage = React.lazy(() => import("pages/SetPasswordPage"));
const AssetsPage = React.lazy(() => import("pages/AssetsPage"));

const DiscoverPage = React.lazy(() => import("pages/DiscoverPage"));
const CollectionPage = React.lazy(() => import("pages/DiscoverPage/CollectionPage"));
const WhatsNewPage = React.lazy(() => import("pages/WhatsNewPage"));
const NotificationsPage = React.lazy(() => import("pages/NotificationsPage"));
const ReportsPage = React.lazy(() => import("pages/ReportsPage"));
const HmSupplierListPage = React.lazy(() => import("pages/HmSupplierListPage"));
const PhotoshootsPage = React.lazy(() => import("pages/PhotoshootsPage"));
const StudioProjectsPage = React.lazy(() => import("pages/StudioProjectsPage"));
const PhotoshootStudioPage = React.lazy(() => import("pages/PhotoshootStudioPage"));
const StudioProjectDetailPage = React.lazy(() => import("pages/StudioProjectDetailPage"));
const TechPackLandingPage = React.lazy(() => import("pages/TechPackLandingPage/TechPackLandingPage"));
const TechPackPage = React.lazy(() => import("pages/TechPackPage/TechPackPage"));
const TechPackAssetsPage = React.lazy(() => import("pages/TechPackAssetsPage"));
const FitModelsPage = React.lazy(() => import("pages/FitModelsPage/FitModelsPage"));
const SvgEditorPage = React.lazy(() => import("pages/SvgEditorPage/SvgEditorPage"));
const MarketplaceStudioPage = React.lazy(() => import("pages/MarketplaceStudioPage"));
const BulkProcessPage = React.lazy(() => import("pages/BulkProcessPage"));

const Account = React.lazy(() => import("pages/Account"));
const SharedPage = React.lazy(() => import("pages/SharedPage"));
const Explore = React.lazy(() => import("pages/Explore"));
const ExploreNews = React.lazy(() => import("pages/Explore/News"));
const ExploreTutorials = React.lazy(() => import("pages/Explore/Tutorials"));
const NewPassword = React.lazy(() => import("pages/NewPassword"));
const EmailVerified = React.lazy(() => import("pages/EmailVerified"));
const PricingPage = React.lazy(() => import("pages/PricingPage"));
const PrivacyPolicy = React.lazy(() => import("pages/PrivacyPolicy"));
const TermsOfUse = React.lazy(() => import("pages/TermsOfUse"));
const AcceptInvite = React.lazy(() => import("pages/AcceptInvite"));
const AcceptMemberInvite = React.lazy(() => import("pages/AcceptMemberInvite"));
const Test = React.lazy(() => import("pages/Test"));
const CancelPlanPage = React.lazy(() => import("pages/CancelPlanPage"));

const DesignStudioPage = React.lazy(() => import("pages/DesignStudioPage"));
const DesignCanvasAgentPage = React.lazy(() => import("pages/DesignCanvasAgentPage"));
const AgentHomePage = React.lazy(() => import("pages/DesignCanvasAgentPage/home/AgentHomePage"));
const HomeRoute = React.lazy(() => import("pages/Home/HomeRoute"));
const AgentChatKitPage = React.lazy(() => import("pages/DesignCanvasAgentPage/kit/AgentChatKitPage"));
const GenUiPage = React.lazy(() => import("pages/DesignCanvasAgentPage/genui/GenUiPage"));
const GenUi2Page = React.lazy(() => import("pages/DesignCanvasAgentPage/genui/GenUi2Page"));
const MockChatPage = React.lazy(() => import("pages/DesignCanvasAgentPage/genui/MockChatPage"));
const CanvasProjectsPage = React.lazy(() => import("pages/CanvasProjectsPage/CanvasProjectsPage"));
const CollectionRangePlansPage = React.lazy(() => import("pages/CollectionRangePlansPage"));
const CollectionRangePlanCreatePage = React.lazy(() => import("pages/CollectionRangePlanCreatePage"));
const AllProjectsPage = React.lazy(() => import("pages/AllProjectsPage"));
const UnderConstruction = React.lazy(() => import("pages/UnderConstruction/UnderConstruction"));
const TrendAnalysisPage = React.lazy(() => import("pages/TrendAnalysisPage/TrendAnalysisPage"));
const TrendHistoryPage = React.lazy(() => import("pages/TrendHistoryPage/TrendHistoryPage"));
const TrendInsightsPage = React.lazy(() => import("pages/TrendInsightsPage/TrendInsightsPage"));
const RunwayTrendsPage = React.lazy(() => import("pages/TrendInsightsPage/RunwayTrendsPage"));
const RetailTrendsPage = React.lazy(() => import("pages/TrendInsightsPage/RetailTrendsPage"));
const RetailInsightsPage = React.lazy(() => import("pages/TrendInsightsPage/RetailInsightsPage"));
const ReportPage = React.lazy(() => import("pages/ReportPage"));
const BrandDnaReportPage = React.lazy(() => import("pages/BrandDnaReportPage"));
const ModelDetailPage = React.lazy(() => import("pages/ModelDetailPage"));
const FabricDnaDetailPage = React.lazy(() => import("pages/FabricDnaDetailPage/FabricDnaDetailPage"));
const DevelopersPage = React.lazy(() => import("pages/DevelopersPage/DevelopersPage"));

export interface RouteConfig {
  path: string;
  component: React.LazyExoticComponent<React.ComponentType<any>>;
  layout?: React.ElementType;
  layoutProps?: {
    hiddenFooter?: boolean;
    hiddenHeader?: boolean;
    isSideMenuFixed?: boolean;
    sideMenuCollapsed?: boolean;
    hideDashboardTopBar?: boolean;
    layoutMenu?: React.ElementType;
  };
  needLogin?: boolean;
  requireLogin?: boolean;
  children?: RouteConfig[];
  isResponsive?: boolean;
  paidPlanNeeded?: boolean;
  /**
   * The module the route needs. A LIST means any of them opens it; refused, the first one's upgrade wall answers.
   */
  requiredPermission?: ModuleKey | ModuleKey[];
  /**
   * What `requiredPermission` must grant to ENTER the route. `"enabled"` (the default): the module is usable — anything
   * less gets the upgrade wall. `"visible"`: the module is shown to this account, so a visible-but-disabled (no-plan)
   * account opens the workspace and meets the paywall on the paid request instead (REF-7279, Design Canvas — the
   * Photoshoot model of REF-7256). A hidden module still redirects, without an upsell.
   */
  permissionMode?: "enabled" | "visible";
  permissionRedirect?: string;
  permissionScreen?: ScreenType;
  /**
   * The route's plain twin, for a user without `requiredPermission`: they land there with the same query instead of
   * the upsell. The agent chat's canvas (`/design-canvas-agent?id=`) falls back to the same canvas without the chat
   * (`/design-canvas?id=`) — the chat is a beta grant, not something to sell.
   */
  permissionFallback?: string;
  theme?: "light" | "dark";
}

export const ROUTES: RouteConfig[] = [
  {
    path: PATHS.REPORT,
    component: ReportPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { hiddenHeader: true },
    theme: "light",
  },
  {
    path: PATHS.BRAND_DNA_REPORT,
    component: BrandDnaReportPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { hiddenHeader: true, sideMenuCollapsed: true },
    theme: "light",
  },
  {
    path: PATHS.MODEL_DETAIL,
    component: ModelDetailPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
  },
  {
    path: PATHS.FABRIC_DNA_DETAIL,
    component: FabricDnaDetailPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
  },
  {
    path: PATHS.TREND_ANALYSIS,
    component: TrendAnalysisPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  // Trend History's gates are the entitlement rules book's (product owner 2026-11-02): Runway Trends / Runway Data are
  // `trends`, Retail Trends / Retail Data are `brand_catalogue` — the BE asks the same. `trend_history` is no permission.
  // Trends Data and its stories read the trend-history tree: the runway grant, `trends`. Full screen:
  // no menu, no header.
  // Retail Data (2026-10-28): Runway Data on retail (pages/TrendDataPage/RetailPages.tsx), behind `brand_catalogue`.
  // Full screen, as Runway Data.
  {
    path: PATHS.RETAIL_DATA,
    component: RetailDataPage,
    layout: MinimalLayout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "brand_catalogue",
    permissionRedirect: PATHS.HOME,
    isResponsive: false,
  },
  {
    path: PATHS.RETAIL_DATA_GROUP,
    component: RetailDataStoryPage,
    layout: MinimalLayout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "brand_catalogue",
    permissionRedirect: PATHS.HOME,
    isResponsive: false,
  },
  {
    path: PATHS.RETAIL_DATA_TYPE,
    component: RetailDataStoryPage,
    layout: MinimalLayout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "brand_catalogue",
    permissionRedirect: PATHS.HOME,
    isResponsive: false,
  },
  {
    path: PATHS.TRENDS_HISTORY,
    component: TrendsHistoryPage,
    layout: MinimalLayout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "trends",
    permissionRedirect: PATHS.HOME,
    isResponsive: false,
  },
  {
    path: PATHS.TREND_DATA,
    component: TrendDataPage,
    layout: MinimalLayout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "trends",
    permissionRedirect: PATHS.HOME,
    isResponsive: false,
  },
  {
    path: PATHS.TREND_DATA_TYPE,
    component: TrendDataPage,
    layout: MinimalLayout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "trends",
    permissionRedirect: PATHS.HOME,
    isResponsive: false,
  },
  {
    path: PATHS.TREND_HISTORY,
    component: TrendHistoryPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "trends",
    permissionRedirect: PATHS.HOME,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  // Trend History's next page (Insights), on its own path until it replaces /trend-history: the same grant.
  {
    path: PATHS.TREND_HISTORY_V2,
    component: RunwayTrendsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "trends",
    permissionRedirect: PATHS.HOME,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.TREND_HISTORY_V2_SEASON,
    component: TrendInsightsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "trends",
    permissionRedirect: PATHS.HOME,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.TREND_HISTORY_V2_CITY,
    component: TrendInsightsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "trends",
    permissionRedirect: PATHS.HOME,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  // Retail Trends (REF-7160): `brand_catalogue`, as the BE's retail routes ask.
  {
    path: PATHS.RETAIL_TRENDS,
    component: RetailTrendsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "brand_catalogue",
    permissionRedirect: PATHS.HOME,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.RETAIL_TRENDS_WINDOW,
    component: RetailInsightsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "brand_catalogue",
    permissionRedirect: PATHS.HOME,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.TEST,
    component: Test,
    layout: Layout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: true,
  },
  {
    path: PATHS.ACADEMY_HOME,
    component: AcademyPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.ACADEMY_ALL_COURSES,
    component: AcademyAllCourses,
    layout: AcademyLayout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: false,
    theme: "dark",
  },
  {
    path: PATHS.ACADEMY_COURSE_WATCH,
    component: AcademyWatchPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.ACADEMY_COURSE,
    component: AcademyDetailPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.ACADEMY_CERTIFICATE_VERIFY,
    component: AcademyVerifyPage,
    // Public verify landing behind the LinkedIn share link — no authed shell (a logged-out
    // recipient of the link must be able to open it). See MinimalLayout. REF-5778.
    layout: MinimalLayout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: true,
    theme: "light",
  },
  // Clean top-level subtype showcase routes (no /assets prefix). Both base + :type render the same
  // full-grid MyAssetsPage view; it reads the pathname + :type to pick the tab, filter, and breadcrumb.
  ...[PATHS.DESIGN_ASSETS, PATHS.DESIGN_ASSETS_TYPE, PATHS.PHOTOSHOOT_ASSETS, PATHS.PHOTOSHOOT_ASSETS_TYPE, PATHS.HISTORY, PATHS.HISTORY_TYPE].map((path) => ({
    path,
    component: AssetsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  })),
  {
    path: PATHS.LOGIN,
    component: Login,
    layout: Layout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: true,
    theme: "light",
  },
  {
    path: PATHS.SIGNUP,
    component: SignUp,
    layout: Layout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: true,
    theme: "light",
  },
  {
    path: PATHS.CHECKOUT,
    component: CheckoutPage,
    layout: Layout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: true,
    theme: "light",
  },
  {
    path: PATHS.AUTH_MAGIC,
    component: AuthMagicPage,
    // Standalone auth/transition screen — never draw the authed app shell (it would
    // render the sidebar/top-bar around the magic-link welcome if a user is already
    // logged in, and fire gated calls). See MinimalLayout.
    layout: MinimalLayout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: true,
    theme: "light",
  },
  {
    path: PATHS.AUTH_IMPERSONATE,
    component: ImpersonatePage,
    // Standalone auth/transition screen (admin "Login as User") — never draw the authed
    // app shell; a currently-logged-in admin's sidebar/top-bar + gated calls must not
    // render while we swap identity and hard-reload. See MinimalLayout. REF-5759.
    layout: MinimalLayout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: true,
    theme: "light",
  },
  {
    path: PATHS.GUEST_SUCCESS,
    component: GuestSuccessPage,
    // Standalone post-checkout screen — minimal shell (no authed sidebar/top-bar). See MinimalLayout.
    layout: MinimalLayout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: true,
    theme: "light",
  },
  {
    path: PATHS.SET_PASSWORD,
    component: SetPasswordPage,
    // MinimalLayout (not the full app shell): a gated guest sits here with a
    // must_set_password token; the authed shell would 403 on mount. See MinimalLayout.
    layout: MinimalLayout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: true,
    theme: "light",
  },
  {
    path: PATHS.TECH_PACK_LANDING,
    component: TechPackLandingPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true, sideMenuCollapsed: true },
    isResponsive: false,
  },
  {
    path: PATHS.TECH_PACK,
    component: TechPackPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "design",
    permissionRedirect: PATHS.TECH_PACK_LANDING,
    permissionScreen: ScreenType.TechPack,
    layoutProps: { isSideMenuFixed: true, sideMenuCollapsed: true },
    isResponsive: false,
  },
  {
    path: PATHS.SVG_EDITOR,
    component: SvgEditorPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: false,
    layoutProps: { hiddenHeader: true },
    isResponsive: false,
  },
  {
    path: PATHS.TECH_PACKS,
    component: TechPackAssetsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  // Fit Models (v3 fit profiles). Shipped on — no env flag (2026-10-14).
  {
    path: PATHS.FIT_MODELS,
    component: FitModelsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.MARKETPLACE_STUDIO,
    component: MarketplaceStudioPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.BULK_PROCESS,
    component: BulkProcessPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true, sideMenuCollapsed: true },
    isResponsive: false,
  },
  {
    path: PATHS.BULK_PROCESS_CONVERT,
    component: BulkProcessPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true, sideMenuCollapsed: true },
    isResponsive: false,
  },
  // The home: the design agent's home for a user with the chat (`agent_chat`), the old `pages/Home` for the rest (`HomeRoute`).
  { path: PATHS.HOME, component: HomeRoute, layout: Layout, requireLogin: true, paidPlanNeeded: false, layoutProps: { isSideMenuFixed: true }, isResponsive: true },
  // The agent home's working address, kept so links already shared still land; without the chat it is the home.
  {
    path: PATHS.DESIGN_CANVAS_AGENT_HOME,
    component: AgentHomePage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: false,
    requiredPermission: "agent_chat",
    permissionFallback: PATHS.HOME,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    // Was /trends — kept as a redirect (see Router.tsx) and now mounted at /moodboards.
    path: PATHS.MOODBOARDS,
    component: TrendsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  // Left-menu deep links into the Moodboards tabs — all render TrendsPage, which reads the
  // pathname to preselect My / Runway / Brand Catalogues. Same guards as /moodboards.
  // …and their `:id` children (REF-6484), which render the SAME page: TrendsPage reads the id off
  // the route and opens that board's detail, so a moodboard finally has a URL to link to.
  ...[
    PATHS.MOODBOARDS_MY,
    PATHS.MOODBOARDS_RUNWAY,
    PATHS.MOODBOARDS_BRAND_CATALOGUES,
    PATHS.MOODBOARDS_SHARED,
    PATHS.MOODBOARDS_MY_DETAIL,
    PATHS.MOODBOARDS_RUNWAY_DETAIL,
    PATHS.MOODBOARDS_BRAND_CATALOGUES_DETAIL,
    PATHS.MOODBOARDS_SHARED_DETAIL,
  ].map((path) => ({
    path,
    component: TrendsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  })),
  // The tabbed /brand-dnas library is retired — Router.tsx redirects the whole prefix to the
  // canonical surfaces. BrandDnasPage itself STAYS: it still renders the two standalone asset
  // pages below, which is the reason the component could not simply be deleted with the route.
  {
    path: PATHS.FABRIC_TRAININGS,
    component: BrandDnasPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    // Design Assets > Color Palettes — a dedicated static route, same flags as FABRIC_TRAININGS
    // above (coexists with the DESIGN_ASSETS_TYPE catch-all without being swallowed by it). REF-6361.
    path: PATHS.DESIGN_ASSETS_COLOR_PALETTES,
    component: ColorPalettesPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    // Design Assets > Brand Kits — a dedicated static route, same flags as the Color Palettes route
    // above. Backed by the real API (REF-6155-brand-kits): `api/brand-kits`, not mock data.
    path: PATHS.DESIGN_ASSETS_BRAND_KITS,
    component: BrandKitsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.PHOTOSHOOT_ASSETS_MODELS,
    component: BrandDnasPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    // Standalone Browzwear boards page — recovered from the retired /assets tabbed page's
    // Integrations tab. Left-menu entry under My Assets → directly below Photoshoot Assets.
    path: PATHS.INTEGRATIONS,
    component: IntegrationsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    // REF-6702 — OAuth return page for the Miro connection. Chrome-less: it only shows a spinner and
    // navigates on. `requireLogin` because the callback POST is authenticated and state is bound to the user.
    path: PATHS.MIRO_CALLBACK,
    component: MiroCallbackPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: false, hiddenHeader: true },
    isResponsive: true,
  },
  {
    // REF-5966 — the single unified create-moodboard page. Floating-window page that
    // opens on top of the previous route (typically the canvas); no layout chrome —
    // the page renders the window itself, and a backdrop dims whatever's underneath.
    // Left source panel (Assets / Trends tabs) + right category sections
    // (Images / Colors / Fabrics / Prints, each add-or-extract).
    path: PATHS.CREATE_MOODBOARD,
    component: CreateMoodboardAddPage,
    requireLogin: true,
    paidPlanNeeded: true,
    isResponsive: false,
  },
  {
    // REF-6155-brand-kits — Create-Brand-Kit page, cloned from CREATE_MOODBOARD above.
    // Floating-window page (no layout chrome) with the same Assets-only source panel +
    // category-sections body; submit goes to the real `api/brand-kits` create endpoint.
    path: PATHS.CREATE_BRAND_KIT,
    component: CreateBrandKitAddPage,
    requireLogin: true,
    paidPlanNeeded: true,
    isResponsive: false,
  },
  {
    // REF-6155-brand-kits — Brand Kit detail/edit screen. Same component as CREATE_BRAND_KIT
    // above (CreateBrandKitAddPage detects `:id` and renders in `isEdit` mode); declared after
    // the static CREATE_BRAND_KIT route so "/brand-kits/new" keeps matching that one first.
    path: PATHS.BRAND_KIT_DETAIL,
    component: CreateBrandKitAddPage,
    requireLogin: true,
    paidPlanNeeded: true,
    isResponsive: false,
  },
  {
    // REF-6157 — virtual-studio background generation. Floating-window page (no layout chrome, like
    // /moodboards/new): left source panel (Trends / Assets) to pick a reference, right Image Reference
    // + optional prompt, center the generated result. Separate from the flat AddBackgroundModal flow.
    path: PATHS.PHOTOSHOOT_ASSETS_BACKGROUNDS_LIFESTYLE,
    component: CreateBackgroundPage,
    requireLogin: true,
    paidPlanNeeded: true,
    isResponsive: false,
  },
  {
    path: PATHS.CANVAS_PROJECTS,
    component: CanvasProjectsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    // Collection Range Plan — create wizard (prototype). Focused full-screen wizard.
    path: PATHS.COLLECTION_RANGE_PLAN_CREATE,
    component: CollectionRangePlanCreatePage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: true, sideMenuCollapsed: true, hiddenHeader: true },
    isResponsive: false,
  },
  {
    // Collection Range Plan — list (prototype).
    path: PATHS.COLLECTION_RANGE_PLANS,
    component: CollectionRangePlansPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.ALL_PROJECTS,
    component: AllProjectsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  // The Developers section (design §6): the page routes its own screens under `/developers/*`. The bare
  // `/developers` entry is the menu's destination (the route resolvers behind ui-map and the capability
  // graph match declared paths, not splats); both render the same page. Gated by the plan permission
  // `api_usage` (K98) like every other permission route.
  ...[PATHS.DEVELOPERS, PATHS.DEVELOPERS_ALL].map((path) => ({
    path,
    component: DevelopersPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: false,
    requiredPermission: "api_usage",
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  })),
  { path: PATHS.DISCOVER, component: DiscoverPage, layout: Layout, requireLogin: true, paidPlanNeeded: true, layoutProps: { isSideMenuFixed: true }, isResponsive: false },
  // Explore Trends left-menu deep links — DiscoverPage reads the pathname to preselect the source.
  ...[PATHS.DISCOVER_RUNWAY, PATHS.DISCOVER_SOCIAL].map((path) => ({
    path,
    component: DiscoverPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  })),
  // Full screen: a category's data story on its own canvas — no menu, no header.
  // Full bleed: no menu, no header — the collection's wall and a way back.
  { path: PATHS.DISCOVER_COLLECTION, component: CollectionPage, layout: MinimalLayout, requireLogin: true, paidPlanNeeded: true, isResponsive: false },
  { path: PATHS.WHATS_NEW, component: WhatsNewPage, layout: Layout, requireLogin: true, paidPlanNeeded: false, layoutProps: { isSideMenuFixed: true }, isResponsive: false },
  { path: PATHS.NOTIFICATIONS, component: NotificationsPage, layout: Layout, requireLogin: true, paidPlanNeeded: false, layoutProps: { isSideMenuFixed: true }, isResponsive: false },
  // Reports shared with the user's team (REF-7271). No plan or permission gate: the share IS the access, and the API
  // answers the list for the caller's team (`[]` without one — the page's empty state).
  { path: PATHS.REPORTS, component: ReportsPage, layout: Layout, requireLogin: true, paidPlanNeeded: false, layoutProps: { isSideMenuFixed: true }, isResponsive: true },
  // REF-7272: no `requiredPermission` — access is a team share, answered by the API (404 → the page's access-denied state).
  {
    path: PATHS.REPORTS_HM_SUPPLIER_LIST,
    component: HmSupplierListPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: false,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: true,
  },
  {
    path: PATHS.PHOTOSHOOTS,
    component: PhotoshootsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.PHOTOSHOOTS_STUDIO_DETAIL,
    component: StudioProjectDetailPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true, hideDashboardTopBar: true },
    isResponsive: false,
  },
  {
    path: PATHS.PHOTOSHOOTS_STUDIO,
    component: StudioProjectsPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.PHOTOSHOOT_STUDIO,
    component: PhotoshootStudioPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { isSideMenuFixed: true, sideMenuCollapsed: true },
    isResponsive: false,
  },
  { path: PATHS.PAYMENT_SUCCESS, component: PricingPage, layout: Layout, requireLogin: false, paidPlanNeeded: false, layoutProps: { hiddenHeader: true, isSideMenuFixed: false }, isResponsive: true },
  { path: PATHS.PAYMENT_FAIL, component: PricingPage, layout: Layout, requireLogin: false, paidPlanNeeded: false, layoutProps: { hiddenHeader: true, isSideMenuFixed: false }, isResponsive: true },
  { path: PATHS.PRICING, component: PricingPage, layout: Layout, requireLogin: false, paidPlanNeeded: false, layoutProps: { hiddenHeader: true, isSideMenuFixed: false }, isResponsive: true },
  { path: PATHS.ACCEPT_INVITE, component: AcceptInvite, requireLogin: false, layout: Layout, paidPlanNeeded: false, layoutProps: { hiddenHeader: true, isSideMenuFixed: false }, isResponsive: true },
  {
    path: PATHS.ACCEPT_MEMBER_INVITE,
    component: AcceptMemberInvite,
    requireLogin: false,
    layout: Layout,
    paidPlanNeeded: false,
    layoutProps: { hiddenHeader: true, isSideMenuFixed: false },
    isResponsive: true,
  },

  { path: PATHS.ACCOUNT, component: Account, layout: Layout, requireLogin: true, paidPlanNeeded: false, layoutProps: { isSideMenuFixed: true, hiddenHeader: false }, isResponsive: false },
  { path: PATHS.CANCEL_PLAN, component: CancelPlanPage, layout: Layout, requireLogin: true, paidPlanNeeded: true, layoutProps: { isSideMenuFixed: false, hiddenHeader: true }, isResponsive: false },
  /**
   * The design agent: one conversation per canvas, hosting the production canvas. Same gate as the
   * canvas itself. Full-screen like the canvas (no main menu, header or top bar — the chat brings its
   * own); `Layout` is kept for the app's snackbars and error surfaces. Recent chats live in the main menu
   * of the other pages.
   */
  /**
   * The agent chat's component kit: sample data only (no agent, no API, nothing of the user's), so it
   * needs no login. Layout-less: the page is its own frame.
   */
  { path: PATHS.DESIGN_CANVAS_AGENT_KIT, component: AgentChatKitPage, requireLogin: false, paidPlanNeeded: false, isResponsive: false },
  /** Generative UI: the agent's cards being redesigned, on sample data only — as the kit, no login, its own frame. */
  { path: PATHS.DESIGN_CANVAS_AGENT_GEN_UI, component: GenUiPage, requireLogin: false, paidPlanNeeded: false, isResponsive: false },
  /** Generative UI in motion: sample data only — as the kit, no login, its own frame. */
  { path: PATHS.DESIGN_CANVAS_AGENT_GEN_UI_2, component: GenUi2Page, requireLogin: false, paidPlanNeeded: false, isResponsive: false },
  /** The gen-ui cards in a clickable chat, on sample data only — as the kit, no login, its own frame. */
  { path: PATHS.DESIGN_CANVAS_AGENT_MOCK, component: MockChatPage, requireLogin: false, paidPlanNeeded: false, isResponsive: false },
  {
    path: PATHS.DESIGN_CANVAS_AGENT,
    component: DesignCanvasAgentPage,
    layout: Layout,
    layoutProps: { hiddenHeader: true, isSideMenuFixed: false },
    requireLogin: true,
    paidPlanNeeded: true,
    // The chat is the beta grant; without it the same canvas opens without the chat (its `design` gate applies there).
    requiredPermission: "agent_chat",
    permissionFallback: PATHS.DESIGN_STUDIO,
    isResponsive: false,
  },
  {
    path: PATHS.DESIGN_STUDIO,
    component: DesignStudioPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "design",
    // Open on visibility: a no-plan account works in the canvas and the generate request's 402 offers the plan (REF-7279).
    permissionMode: "visible",
    permissionRedirect: "/",
    permissionScreen: ScreenType.Design,
    layoutProps: { hiddenHeader: true, hiddenFooter: true, isSideMenuFixed: false },
    isResponsive: false,
  },
  // /new-training (the landing hub) is retired — it was outside the real training funnel
  // (users start training from the library, which jumps straight to the trainers below) and
  // dead-ended users after a fabric training. It now redirects to /moodboards/my (Router.tsx).
  {
    // Layout-less route — Style Training renders as a full-viewport modal
    // (floating window with backdrop + close X), matching /moodboards/new.
    path: PATHS.STYLE_TRAINING,
    component: StyleTrainingPage,
    requireLogin: true,
    paidPlanNeeded: true,
    isResponsive: false,
  },
  {
    path: PATHS.FABRIC_TRAINING,
    component: FabricTrainingPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    layoutProps: { hiddenHeader: false, isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.MODEL_TRAINING,
    component: ModelTrainingPage,
    layout: Layout,
    requireLogin: true,
    paidPlanNeeded: true,
    requiredPermission: "model_training",
    permissionRedirect: PATHS.PHOTOSHOOT_ASSETS_MODELS,
    layoutProps: { hiddenHeader: false, isSideMenuFixed: true },
    isResponsive: false,
  },
  {
    path: PATHS.RESET_PASSWORD,
    component: NewPassword,
    layout: Layout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { hiddenHeader: true, isSideMenuFixed: false },
    isResponsive: true,
    theme: "light",
  },
  {
    path: PATHS.EMAIL_VERIFY,
    component: EmailVerified,
    layout: Layout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { hiddenHeader: true, isSideMenuFixed: false },
    isResponsive: true,
  },
  {
    path: PATHS.PRIVACY_POLICY,
    component: PrivacyPolicy,
    layout: Layout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { hiddenHeader: true, isSideMenuFixed: false },
    // Reachable on mobile, unlike almost every other page here. Ask Refabric runs on mobile (the
    // launcher is in `MobileTopBar`), and a policy question there produces a route-only referral
    // whose entire content is "go and read this document" plus a CTA to this route. With
    // `isResponsive: false` that CTA landed on the mobile-restriction panel — the assistant told
    // the user to read the policy and the app then refused to show it. Static long-form prose in a
    // `max-w-[865px]` column, no interactive surface, so there is nothing here that needs a desktop.
    isResponsive: true,
  },
  {
    path: PATHS.TERMS_OF_USE,
    component: TermsOfUse,
    layout: Layout,
    requireLogin: false,
    paidPlanNeeded: false,
    layoutProps: { hiddenHeader: true, isSideMenuFixed: false },
    // Same reasoning as PRIVACY_POLICY above — the ownership / licensing / refund-terms referral
    // sends mobile users here.
    isResponsive: true,
  },
  { path: PATHS.ACCOUNT, component: Account, layout: Layout, requireLogin: true, paidPlanNeeded: true, layoutProps: { isSideMenuFixed: true }, isResponsive: false },
  { path: PATHS.Shared, component: SharedPage, layout: Layout, requireLogin: true, paidPlanNeeded: true, layoutProps: { isSideMenuFixed: true }, isResponsive: false },
  { path: PATHS.EXPLORE, component: Explore, layout: Layout, requireLogin: true, paidPlanNeeded: true, layoutProps: { isSideMenuFixed: true }, isResponsive: false },
  { path: PATHS.EXPLORE_NEWS, component: ExploreNews, layout: Layout, requireLogin: true, paidPlanNeeded: true, layoutProps: { isSideMenuFixed: true }, isResponsive: false },
  { path: PATHS.EXPLORE_TUTORIALS, component: ExploreTutorials, layout: Layout, requireLogin: true, paidPlanNeeded: true, layoutProps: { isSideMenuFixed: true }, isResponsive: false },
  { path: PATHS.MAINTENANCE, component: UnderConstruction, requireLogin: false, paidPlanNeeded: false, layoutProps: { hiddenHeader: true, hiddenFooter: true }, isResponsive: true },
];
